import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { ReactComponent as LoadingIcon } from '../../../assets/svg/loading.svg';
import axiosInstant from '../../../api';
import UserEditForm from './form';
import { updateUserProTeam } from '../../../api/endpoints';
import { MainContainer } from '../../../components/ContentWrapper';

const AdminEditUser = () => {
  const params = useParams();
  const [user, setUser] = useState({} as any);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const { id } = params;
    if (id) {
      getUserData(id);
    } else {
      setLoading(false);
    }
  }, []);

  const getUserData = (id: string) => {
    axiosInstant
      .get(`/admin/users/${id}`)
      .then((result: any) => {
        setUser(result.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleSubmit = async (values: any, actions: any) => {
    try {
      await axiosInstant.patch(updateUserProTeam(values.userid), values);
      actions.setSubmitting(false);
      toast.success('User updated successfully.', { duration: 3000 });
    } catch (error: any) {
      const errorMessage = error?.response?.data;
      if (errorMessage === 'EmailAlreadyExists') {
        toast.error('A user with this email already exists.');
      } else {
        toast.error('Failed to update user. Please try again.');
      }
      actions.setSubmitting(false);
    }
  };

  return (
    <MainContainer title="edit user">
      <Box padding={4} sx={{ backgroundColor: 'var(--surface)' }} borderRadius={4}>
        {loading && <LoadingIcon />}
        {!loading && !user.userid && (
          <Typography>404 User Not Found</Typography>
        )}
        {!loading && user.userid && (
          <UserEditForm user={user} handleSubmit={handleSubmit} />
        )}
      </Box>
    </MainContainer>
  );
};

export default AdminEditUser;
